import React from 'react';

import { COLORS } from '../theme';

const Icon = <span className="MuiRadio-icon" />;

export default {
  defaultProps: {
    disableRipple: true,
    icon: Icon,
    checkedIcon: Icon,
  },
  styleOverrides: {
    root: {
      // icon

      '.MuiRadio-icon': {
        display: 'inline-block',
        width: 20,
        height: 20,
        border: `2px solid ${COLORS.black30}`,
        borderRadius: '50%',
      },

      '&.Mui-checked .MuiRadio-icon': {
        borderColor: COLORS.green,
        borderWidth: 5,
      },

      '&.Mui-disabled .MuiRadio-icon': {
        borderColor: COLORS.black10,
      },

      '&.Mui-disabled.Mui-checked .MuiRadio-icon': {
        borderColor: COLORS.black30,
      },

      '&.Mui-focusVisible .MuiRadio-icon': {
        boxShadow: `0 0 0 1px ${COLORS.white}, 0 0 0 3px ${COLORS.green}`,
      },

      // label

      '& + .MuiFormControlLabel-label': {
        color: COLORS.black60,
      },

      '&.Mui-checked + .MuiFormControlLabel-label': {
        color: 'inherit',
      },

      '&.Mui-disabled + .MuiFormControlLabel-label': {
        color: COLORS.black30,
      },
    },
  },
};
